export const OPEN_SIMPLE_DIALOG = 'OPEN_SIMPLE_DIALOG';
export const CLOSE_SIMPLE_DIALOG = 'CLOSE_SIMPLE_DIALOG';